import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

export const getEditorSubdivisionColumns = (
  t: TFunction,
  options: string[]
): ColumnsType<any> =>
  options.map((option) => ({
    title: t(`editorSubdivision.${option}`),
    dataIndex: option,
    key: option,
    render: (value: any) => <span>{value}</span>,
  }));
